import type { LiveCall } from './use-live-call';

/**
 * A call as the boards show it (D28, D61, mobile 25), for `/desktop-preview/pages/live` and the
 * component tests: two minutes in, the assistant speaking, two conversations it works with.
 * Its actions do nothing.
 */
export function previewLiveCall(overrides: Partial<LiveCall> = {}): LiveCall {
  const nothing = () => undefined;
  return {
    status: 'speaking',
    muted: false,
    transcript: [
      { role: 'user', text: 'Où en est la CI ?' },
      {
        role: 'assistant',
        text: 'La PR de la CI est prête. Tu veux que je la passe en revue avec toi ?',
      },
    ],
    activity: null,
    steps: [],
    followed: [
      {
        conversation: '3e1f6a85-9db0-4f92-8d84-5c9f4b3dae44',
        label: 'Opened PR #556 · Accélération CI',
      },
      {
        conversation: '4f2a7b96-aec1-4fa3-9e95-6dae5c4ebf55',
        label: 'Started « Cache Docker layers »',
      },
    ],
    request: null,
    assistant: null,
    speaker: null,
    assistants: [],
    error: null,
    start: async () => undefined,
    hangUp: nothing,
    switchTo: nothing,
    group: null,
    groupSpeaker: null,
    groupThinking: null,
    invite: nothing,
    toggleMute: nothing,
    answer: nothing,
    type: nothing,
    dismissError: nothing,
    ...overrides,
  } as LiveCall;
}
